import { reactive } from 'vue'
import { delay } from '@libs/utils/tools'
enum DialogType {
  notice,
  confirm,
  waiting,
  restart,
  alert,
}

let dialogContent = reactive({
  isSuccess: false,
  dialogType: DialogType.notice,
  content: '',
  confirmLabel: null as null | string,
  cancelLabel: null as null | string,
  reject: null as null | ((reason: string) => void),
  resolve: null as null | ((reason: boolean) => void),
})

let task: any
interface EnableDialogOptions {
  confirmLabel?: string
  cancelLabel?: string
}
let enableDialog = async (content: string, dtype?: DialogType, isSuccess?: boolean, timer: number = 2000, options?: EnableDialogOptions) => {
  if (task) {
    clearTimeout(task)
    task = null
  }

  // 如果当前已有正在进行的交互式弹窗，先 resolve/reject 掉上一个
  if (dialogContent.resolve && dialogContent.dialogType !== DialogType.notice) {
    dialogContent.resolve(false)
  }

  dialogContent.content = content
  dialogContent.dialogType = dtype !== undefined ? dtype : DialogType.notice
  dialogContent.isSuccess = isSuccess !== undefined ? isSuccess : true
  dialogContent.confirmLabel = options?.confirmLabel ?? null
  dialogContent.cancelLabel = options?.cancelLabel ?? null

  return new Promise((resolve: (reason: boolean) => void, reject: (reason: string) => void) => {
    dialogContent.reject = reject
    dialogContent.resolve = resolve

    if (content !== '' && dialogContent.dialogType === DialogType.notice) {
      task = setTimeout(() => {
        dialogContent.content = ''
        if (dialogContent.resolve) {
          dialogContent.resolve(true)
          dialogContent.resolve = null
          dialogContent.reject = null
        }
        task = null
      }, timer)
    }
  })
}

const clearTask = () => {
  if (task) {
    clearTimeout(task)
    task = null
  }
  dialogContent.content = ''
}

export { dialogContent, DialogType, enableDialog }
